import script from "./StudentPaperView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentPaperView.vue?vue&type=script&setup=true&lang=ts"

import "./StudentPaperView.vue?vue&type=style&index=0&id=1951e5a2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1951e5a2"]])

export default __exports__